import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { CirculationStatus } from "../../../interfaces";
import {
  IStepInit,
  Step,
  StepResult,
  StepStatus
} from "../../../interfaces/step";
import { LogClass, LogMethod } from "../../../logger";

@Component({
    selector: "circ-step-status",
    templateUrl: "./step-status.component.html",
    styleUrls: ["./step-status.component.scss"],
    standalone: false
})
@LogClass()
export class StepStatusComponent implements OnInit, OnChanges {
  public status?: StepStatus = null;
  public result?: StepResult = null;
  public hasErrors?: boolean = null;

  @Input() public step: IStepInit;
  @Input() public circStatus: CirculationStatus;

  @LogMethod()
  public ngOnInit(): void {
    this.setResult();
  }

  private setResult(): void {
    const status = this.step.status;
    this.status = status;

    const result = Step.getStepResult(this.step);
    this.result = result;

    const hasErrors = Step.getHasErrors(this.step);
    this.hasErrors = hasErrors;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof changes["step"] === "undefined") {
      return;
    }

    this.setResult();
  }
}
